var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMember1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_10007)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#76EED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9772 26.8241L5.07318 26.6305C5.12575 23.5858 5.83414 20.596 7.38262 17.9205C8.39961 16.1634 8.37764 14.2511 8.13255 12.64C7.75434 10.1538 8.63383 7.61 10.5882 6.02735C12.0817 4.81576 13.9667 4.19209 15.8881 4.27378L16.294 4.29069C17.6162 4.34564 18.9034 4.73187 20.0374 5.41391C21.1714 6.09595 22.1158 7.05195 22.7841 8.19413C23.4633 9.41346 23.7372 10.8172 23.5662 12.2024C23.4337 13.5058 23.7508 14.8224 24.4924 16.1516C25.7718 19.0704 26.0489 22.8053 25.9772 26.8241Z",
    fill: "#131720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5121 21.8537L15.4666 29.3333L11.4374 23.6205C12.329 21.5743 12.6851 19.6038 12.3293 17.7341H19.1076C19.0922 19.1697 18.7841 19.3509 19.5121 21.8537Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0368 19.5531C18.1125 20.2478 16.9633 20.6594 15.718 20.6594C14.4983 20.6594 13.3708 20.2645 12.4564 19.5955C12.4857 18.9649 12.4454 18.3441 12.3293 17.7341H19.246C19.0705 18.2076 18.9987 18.8373 19.0368 19.5531Z",
    fill: "#EBA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2419 57.3334L6.26392 58.7605L8.31517 23.3529L11.7935 22.3718L15.4667 27.7333L19.5122 21.8536L22.2439 23.4146L26.2419 57.3334Z",
    fill: "#6191EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.054 43.9556L-2.1189 40.7449L2.29267 27.8242C2.78471 26.491 3.72714 25.3716 4.95704 24.6595L6.24381 23.8049L5.55127 36.8206L3.054 43.9556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7742 43.1701L32.958 41.5646L26.5365 34.2511L27.317 24.9756L38.3093 39.9592L37.7742 43.1701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.718 19.5182C18.772 19.5182 21.2477 17.0425 21.2477 13.9885C21.2477 10.9346 18.772 8.45886 15.718 8.45886C12.6641 8.45886 10.1884 10.9346 10.1884 13.9885C10.1884 17.0425 12.6641 19.5182 15.718 19.5182Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5342 12.5615C17.4628 11.2985 14.4293 11.2071 11.437 12.3831L10.1884 7.92371H21.6044L20.5342 12.5615Z",
    fill: "#131720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1114 80.6786C33.8045 83.1704 23.0387 84.5594 18.3117 82.8191C17.9639 70.6619 17.3297 36.4021 19.5192 21.8536L27.317 24.9756L26.6062 34.5684C22.8539 42.8083 33.7496 71.508 38.1114 80.6786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65393 82.8411L-3.99182 79.7196C0.065773 66.2641 3.90242 35.9024 6.24389 23.8049L12.0975 21.8536L9.65393 82.8411Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_10007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMember1);
export default __webpack_public_path__ + "static/media/teamMember1.9c03d871.svg";
export { ForwardRef as ReactComponent };